import { ArchiveType, isPersonalPageArchiveType, PersonalPageArchiveType } from '../../archive-type';
import { isPersonalPageSubtype } from './guards';
import type { ArchiveCreationFlow, PersonalPageFamily, PersonalPageSubtype } from './types';

/**
 * Focused-donation (ticket inventory) archive templates with open-amount UX:
 * max inventory by default, no sold/remaining display, non-inventory units copy.
 */
export const FOCUSED_DONATION_OPEN_AMOUNT_ARCHIVE_IDS = [10388] as const;

const FOCUSED_DONATION_OPEN_AMOUNT_ARCHIVE_ID_SET = new Set<number>(FOCUSED_DONATION_OPEN_AMOUNT_ARCHIVE_IDS);

export function isFocusedDonationOpenAmountArchive(archiveDataId?: number | string | null): boolean {
  if (archiveDataId == null || archiveDataId === '') return false;
  const id = Number(archiveDataId);
  return Number.isFinite(id) && FOCUSED_DONATION_OPEN_AMOUNT_ARCHIVE_ID_SET.has(id);
}

/** Read subtype from archive template: personalPageType holds subtype; archiveType holds family */
export function parseArchivePersonalPageType(
  personalPageType?: string,
  archiveType?: string
): PersonalPageSubtype | undefined {
  if (isPersonalPageSubtype(personalPageType)) {
    return personalPageType;
  }
  if (personalPageType === 'registration') {
    return 'serviceRegistration';
  }
  if (personalPageType === 'event') {
    return 'choiceEvent';
  }
  if (archiveType === ArchiveType.donationsArchive) {
    return 'choiceDonation';
  }
  if (archiveType === ArchiveType.eventsArchive) {
    return 'choiceEvent';
  }
  if (archiveType === ArchiveType.informationPagesArchive) {
    return 'fixedFormLead';
  }
  return undefined;
}

const ARCHIVE_TYPE_TO_FAMILY: Record<PersonalPageArchiveType, PersonalPageFamily> = {
  [ArchiveType.donationsArchive]: 'campaign',
  [ArchiveType.eventsArchive]: 'event',
  [ArchiveType.informationPagesArchive]: 'information'
};

export function getFamilyFromArchiveType(archiveType?: string): PersonalPageFamily | undefined {
  return isPersonalPageArchiveType(archiveType) ? ARCHIVE_TYPE_TO_FAMILY[archiveType] : undefined;
}

export function resolveArchiveCreationFlow(archiveType: string): ArchiveCreationFlow {
  const family = getFamilyFromArchiveType(archiveType);

  if (family === 'campaign') {
    return 'campaign';
  }
  if (family === 'information') {
    return 'information';
  }
  return 'event';
}
